import { CurrencyPipe, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PricePipe } from '@app/core/pipes/price.pipe';
import { Invoice } from '@app/entities/invoices/interfaces/invoice';
import { DownloadInvoice } from '@app/store';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-invoice-item',
  templateUrl: './invoice-item.component.html',
  styleUrls: ['./invoice-item.component.scss'],
  imports: [PricePipe, DatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CurrencyPipe],
})
export class InvoiceItemComponent {
  constructor(private store: Store) {}

  @Input({ required: true })
  invoice!: Invoice;

  onDownloadInvoice(invoiceId: number): void {
    this.store.dispatch(new DownloadInvoice(invoiceId));
  }
}
